import axios from "axios";
import { apiConfig } from "../../config/api";
import secureStorage from "../../utils/secureStorage";

const API_BASE_URL = apiConfig.basePath;

// POST request to get-poll
export const getPolls = async (payload = {}) => {
  try {
    const token = secureStorage.getItem("accessToken");
    // Accept page, limit, and type for pagination and filtering
    const { page = 1, limit = 10, type } = payload;
    const requestBody = { page, limit };

    // Add type parameter if specified (1 = my polls, 2 = requested polls)
    if (type) {
      requestBody.type = type;
    }

    const response = await axios.post(`${API_BASE_URL}get-poll`, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to fetch polls");
    } else {
      throw new Error("Network error fetching polls");
    }
  }
};

// POST request to create-poll
export const createPoll = async (payload) => {
  try {
    const token = secureStorage.getItem("accessToken");
    const response = await axios.post(`${API_BASE_URL}create-poll`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to create poll");
    } else {
      throw new Error("Network error creating poll");
    }
  }
};

// Get poll details by poll_id with pagination
export const getPollDetails = async (poll_id, page = 1) => {
  try {
    const token = secureStorage.getItem("accessToken");

    const response = await axios.post(
      `${API_BASE_URL}get-poll-votes`,
      { poll_id, page }, // <-- include pagination here
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(
        error.response.data?.message || "Failed to fetch poll details"
      );
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw new Error("Error: " + error.message);
    }
  }
};

// POST request to vote-on-poll
export const voteOnPoll = async (poll_id, selected_options) => {
  try {
    const token = secureStorage.getItem("accessToken");
    const response = await axios.post(
      `${API_BASE_URL}vote-on-poll`,
      { poll_id, selected_options },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to vote on poll");
    } else {
      throw new Error("Network error voting on poll");
    }
  }
};
